<template>
  <div>
    <reset-password />
  </div>
</template>
<script>
import ResetPassword from '@/components/Auth/ResetPassword';
export default {
  components: {
    ResetPassword,
  },
};
</script>
